



















































import Vue from 'vue';
import { simpleSearch } from '~/services/search';

export default Vue.extend({
  components: {},
  props: {
    data: {
      type: Object,
      default: null,
    },
    props: {
      type: Object,
      default: null,
    },
  },
  data() {
    return { comment: '' };
  },
  mounted() {
    (this.$refs.searchInput as any).focus();
  },
  methods: {
    getJobs() {
      let jobs = this.props.jobs;
      jobs = jobs.filter((job: any) => {
        if (
          !job.id &&
          this.comment.length > 3 &&
          !this.props.hourlyRateOrdersDisabled
        ) {
          return true;
        } else if (job.id) {
          return simpleSearch(
            this.$loc(job.localizedTitle) || '',
            this.comment
          );
        } else {
          return false;
        }
      });
      return jobs;
    },
    focusSearch() {
      (this.$refs.searchInput as any).focus();
    },
    selectJob(job: any) {
      const eventData = {
        focusNext: true,
        key: 'job',
        value: {
          jobId: job.id,
          estimate: job.estimate,
          textValue: job.id
            ? this.$loc(job.localizedTitle)
            : this.comment + ', ' + this.$t(job.label),
          comment: this.comment,
        },
      };
      this.$emit('save', eventData);
    },
  },
});
